import React from "react";
import { Switch, Route } from "react-router-dom";
import App from "./App";
// pages //
import LobbyPage from "./LobbyPage";
import EventPage from "./EventPage"; // Event landing page 
import CompanyPage from "./CompanyPage"; // AKA "Booth"
import ChatPage from "./ChatPage";

export default () => (
  <App>
    <Switch>
      <Route exact path='/events/:eventSlug' component={EventPage} />
      <Route exact path='/events/:eventSlug/lobby' component={LobbyPage} />
      <Route exact path='/events/:eventSlug/companies/:companySlug' component={CompanyPage} />
      <Route exact path='/events/:eventSlug/companies/:companySlug/chat' component={ChatPage} />
    </Switch>
  </App>
);
